
import Vue from "vue";
import { mapState } from "vuex";
import Modal from "@/components/Modal.vue";
import Typography from "@/components/Typography.vue";
import RoundButton from "@/components/RoundButton.vue";
import { IRootState } from "@/store/types";
import { UI } from "@/store/ui";
import { APPLICATION } from "@/store/applications";
import { TASK } from "@/store/task";
import { alphaNum, maxLength, required } from "vuelidate/lib/validators";

export default Vue.extend({
  components: {
    Modal,
    Typography,
    RoundButton
  },
  props: {
    isOpen: Boolean
  },
  data() {
    return {
      reason: ""
    };
  },
  computed: {
    showModal: {
      get(): boolean {
        return this.isOpen;
      },
      set(value: boolean) {
        this.$emit("update:isOpen", value);
        const form = this.$refs.form as any;
        // reset the form whenever the modal is closed
        if (!value && form) {
          form.reset();
        }
      }
    },
    ...mapState({
      isLoading: (state: IRootState) => state.application.isLoading,
      applicationId: (state: IRootState) =>
        state.application.applicationData &&
        state.application.applicationData.id
    })
  },
  methods: {
    async onSubmit() {
      const id = (this as any).applicationId;
      const reason = this.reason;
      if (id) {
        const success = await this.$store.dispatch(
          APPLICATION.NS(APPLICATION.ACTIONS.CANCEL_APPLICATION),
          { id, reason }
        );
        if (success) {
          await this.$store.dispatch(
            TASK.NS(TASK.ACTIONS.LOAD_APPLICATION_TIMELINE),
            id
          );

          this.showModal = false;
        }
      }
    }
  },
  validations: {
    reason: {
      required,
      maxLength: maxLength(250)
    }
  }
});
